import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import Container from 'src/ui/molecules/Container'
import WrappedInput from 'src/ui/atoms/Input/Wrapped'
import Button from 'src/ui/atoms/Button'

import useAPIKeyGenerateApi, { IaPIKeyGenerateCredentials } from './useAPIKeyGenerateApi'

const APIKeyGenerate = () => {
  const navigate = useNavigate()
  const [token, setToken] = useState('')
  const [copied, setCopied] = useState(false)

  const { generateApiToken } = useAPIKeyGenerateApi()

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  })

  const handleGenerate = async ({ name }: IaPIKeyGenerateCredentials) => {
    try {
      const token = await generateApiToken({ name })

      setToken(token)
    } catch (err) {
      console.error('Forgot password error', err)
    }
  }

  const onCopied = () => {
    setCopied(true)

    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  return (
    <Container title="Generate API Token">
      <div className="flex h-full flex-col justify-between gap-6">
        {token ? (
          <>
            <h3>The API token has been generated.</h3>
            <p>
              Securely store it, you won’t be able to access it again. Do not give access to this
              token to anyone.
            </p>
            <div className="flex gap-2">
              <span className="flex-grow rounded-lg border border-main-blue bg-white bg-opacity-5 px-4 py-3 text-white">
                {token}
              </span>
              <CopyToClipboard text={token} onCopy={onCopied}>
                <Button type="secondary" name={copied ? 'Copied' : 'Copy'} size="M" />
              </CopyToClipboard>
            </div>
            <Button
              className="self-center"
              name="Go to my API keys"
              onClick={() => navigate('/api-keys')}
            />
          </>
        ) : (
          <form
            className="flex flex-col gap-6"
            onSubmit={handleSubmit((data) => handleGenerate(data as IaPIKeyGenerateCredentials))}>
            <div className="grid gap-4">
              <WrappedInput
                placeholder="Type the name"
                label="Name"
                type="text"
                error={errors.name}
                labelPosition="inside"
                {...register('name', {
                  required: 'Required field',
                  pattern: {
                    value: /^[\s\S]{8,}$/,
                    message: 'Name must contain at least 8 characters',
                  },
                })}
              />
            </div>
            <Button className="self-end" name="Generate" disabled={!isValid} />
          </form>
        )}
      </div>
    </Container>
  )
}

export default APIKeyGenerate
